import { type AssetTypeAttachment } from "@overmap-ai/common"
import { selectAssetTypeAttachmentById } from "@overmap-ai/core"
import type { NodeViewProps } from "@tiptap/react"
import { memo } from "react"

import { sdk } from "../../../sdk"
import { useAppSelector } from "../../../store"
import { BaseAttachmentNodeComponent } from "../BaseAttachment/Component"
import { NotFoundAttachmentNode } from "../BaseAttachment/FallbackAttachmentNode"

export const AssetTypeAttachmentNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const attachmentId = node.attrs.uuid as string
	const assetTypeAttachment = useAppSelector(selectAssetTypeAttachmentById(attachmentId))

	if (!assetTypeAttachment) {
		return <NotFoundAttachmentNode {...props} />
	}

	return (
		<BaseAttachmentNodeComponent<AssetTypeAttachment>
			attachment={assetTypeAttachment}
			service={sdk.assetTypeAttachments}
			{...props}
		/>
	)
})
AssetTypeAttachmentNodeComponent.displayName = "AssetTypeAttachmentNodeComponent"
